import SwAppMain from './sw-app-main.vue';

export {
  SwAppMain,
};
